import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const ModalClassName = `${CLASS_NAME_PREFIX}-modal`;
export const ModalContentClassName = `${ModalClassName}__content`;
export const ModalContentHeaderClassName = `${ModalContentClassName}-header`;
export const ModalContentHeaderCloseButtonClassName = `${ModalContentHeaderClassName}-close-button`;
export const ModalContentBodyClassName = `${ModalContentClassName}-body`;
export const ModalContentFooterClassName = `${ModalContentClassName}-footer`;
